interface EnvironmentVariables {
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
    redirectUri: string;
  };
  app: {
    name: string;
    version: string;
    environment: string;
    apiBaseUrl: string;
    apiVersion: string;
    defaultTheme: string;
  };
  features: {
    enableMonitoring: boolean;
    enableDebug: boolean;
  };
}

// Validate environment variables on import (only in browser context)
const validateConfig = (): boolean => {
  // Skip validation during build process
  if (typeof window === 'undefined') {
    return true;
  }

  const requiredVars = [
    'VITE_AUTH0_DOMAIN',
    'VITE_AUTH0_CLIENT_ID',
    'VITE_AUTH0_AUDIENCE',
    'VITE_API_BASE_URL',
    'VITE_APP_NAME',
    'VITE_APP_VERSION',
    'VITE_ENVIRONMENT',
    'VITE_API_VERSION',
    'VITE_DEFAULT_THEME',
  ];

  for (const varName of requiredVars) {
    if (!import.meta.env[varName]) {
      console.error(`Missing required environment variable: ${varName}`);
      return false;
    }
  }

  return true;
};

// Environment configuration object
export const env: EnvironmentVariables = {
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || window?.location?.origin,
  },
  app: {
    name: import.meta.env.VITE_APP_NAME,
    version: import.meta.env.VITE_APP_VERSION,
    environment: import.meta.env.VITE_ENVIRONMENT,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
    apiVersion: import.meta.env.VITE_API_VERSION,
    defaultTheme: import.meta.env.VITE_DEFAULT_THEME,
  },
  features: {
    enableMonitoring: import.meta.env.VITE_ENABLE_MONITORING === 'true',
    enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
  },
};

// Validate configuration
export { validateConfig };

// Development mode check
export const isDevelopment = env.app.environment === 'development';
export const isProduction = env.app.environment === 'production';

// Admin features flag - show admin panel and dev tools to all authenticated users
export const showAdminFeatures = true; 